import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a5606f7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4a5606f7&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5606f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5606f7')) {
      api.createRecord('4a5606f7', component.options)
    } else {
      api.reload('4a5606f7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a5606f7&scoped=true&", function () {
      api.rerender('4a5606f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/index.vue"
export default component.exports